import { Injectable } from '@angular/core';
import { Empleado } from '../entities/empleado';
import { CRUDService } from '../../core/services/crud.service';
import { HttpInt } from 'src/app/httpInt';
import { MensajeUsuarioService } from '../../comun/services/mensaje-usuario.service';
import { HttpClient } from '@angular/common/http';
import { endPoints } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmpleadoJwtService extends CRUDService<Empleado> {

  override httpInt: any;
  headers: any;



  constructor(
    httpInt: HttpInt,
    mensajeUsuarioService: MensajeUsuarioService,
  ) {
    super(httpInt, mensajeUsuarioService)
  }

  getClassName(): string {
    return "EmpleadoJwtService";
  }

  findempleadoByUsuario(parametro: string) {
    console.log("este es el token", parametro);

    return new Promise(resolve => {
      this.httpInt.get(endPoints.EmpleadoJwtService + "buscarempleado/" + parametro)
        .subscribe(
          (res: unknown) => {
            resolve(res);
          }
          ,
          (err: any) => this.manageError(err)
        )
    });
  }

  findSeguimientoByCase(parametro: string) {
    console.log("este es el seguimiento", parametro);

    return new Promise(resolve => {
      this.httpInt.get(endPoints.EmpleadoJwtService + "buscarSeguimiento/" + parametro)
        .subscribe(
          (res: unknown) => {
            resolve(res);
          }
          ,
          (err: any) => this.manageError(err)
        )
    });
  }
  findTypeUserByCase(parametro: string) {
    console.log("este es el usuario", parametro);

    return new Promise(resolve => {
      this.httpInt.get(endPoints.EmpleadoJwtService + "getUserType/" + parametro)
        .subscribe(
          (res: unknown) => {
            resolve(res);
          }
          ,
          (err: any) => this.manageError(err)
        )
    });
  }

  findSeguimientoByID(parametro: string) {
    console.log("este es el usuario", parametro);

    return new Promise((resolve, reject) => {
      this.httpInt.get(endPoints.EmpleadoJwtService + "findSegByID/" + parametro)
        .subscribe(
          (res: unknown) => {
            resolve(res);
          },
          (err: any) => {
            if (err.status === 401) {
              localStorage.setItem('jwtExpired', 'true');
            }
            this.manageError(err);
            reject(err);
          }
        );
    })
  }
};